import { createFileRoute } from '@tanstack/react-router'
import { AppContainer } from '~/components/new/app-ui/app-container'
import { AppHeader } from '~/components/new/app-ui/app-header'
import { Title } from '~/components/new/app-ui/title'
import { InterimAgenciesPage } from '~/components/routes/hr/interim-agencies/interim-agencies-page'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/hr/interim-agencies')({
  staticData: { permission: ['read', 'interim-agencies.interim-agencies.agency'] },
  component: RouteComponent,
})

withRoutePermissions(Route)

function RouteComponent() {
  return (
    <>
      <AppHeader>
        <Title>Agences d'intérim</Title>
      </AppHeader>
      <AppContainer>
        <InterimAgenciesPage />
      </AppContainer>
    </>
  )
}
